<!-- TEMPLATE -->
<template>
  <div style="position: relative;">
    <dean-section-title :content="true" :sidemenuButton="true">
      <span slot="title">{{ service.name }}</span>
      <dean-section-title-item
              :icon="trashIcon"
              :content="true"
              @click.native="removeService"
              v-if="status==='Concept' && service && canUpdateQuote()"
      >
        verwijderen
      </dean-section-title-item>
    </dean-section-title>

    <display-address v-if="service.address" :customer="customer" @address="updateAddress"></display-address>

    <div v-if="data && (!service.address == !address)" v-for="(field, index) in data">

      <!-- no folding, no child fields -->
      <dean-select-form-row
          v-if="!field.foldable && !field.fields && field.options"
          :disabled="status!=='Concept' || !canUpdateQuote()"
          v-bind:key="field.id"
          :label="field.label"
          :options="field.options"
          v-model="field.value"
          @input="inputFieldChanged"
          :clearable="true"
          placeholder="Selecteer"
        >
        </dean-select-form-row>

      <!-- no folding, has child fields -->
      <div v-if="!field.foldable && field.fields">
        <dean-section-divider>{{ field.label }}</dean-section-divider>
          <div
                  v-for="(subfield, subindex) in field.fields"
                  v-bind:key="subindex"
          >
            <dean-form-row
                    :disabled="status!=='Concept' || !canUpdateQuote()"
                    v-if="!subfield.options && !subfield.hasOwnProperty('fields') && subfield.itemMaximum != 1"
                    :label="subfield.label"
                    v-model="subfield.value"
                    :max="subfield.itemMaximum"
                    :min="subfield.itemMinimum"
                    :number="true"
                    @input="inputFieldChanged"
            >
            </dean-form-row>
            <dean-input-switch-form-row
                    v-if="!subfield.options && !subfield.hasOwnProperty('fields') && subfield.itemMaximum == 1"
                    :disabled="status!=='Concept' || subfield.itemMaximum === subfield.itemMinimum || !canUpdateQuote()"
                    :label="subfield.label"
                    :value="subfield.value"
                    @checked="inputFieldChanged(subfield)"
            >

            </dean-input-switch-form-row>
            <dean-accordion
                    v-if="!subfield.options && subfield.hasOwnProperty('fields')"
                    :label="subfield.label"
                    small="true"
            >
              <dean-form-row
                      :disabled="status!=='Concept' || !canUpdateQuote()"
                      v-for="ssubfield in subfield.fields"
                      v-bind:key="ssubfield.id"
                      :label="ssubfield.label"
                      :min="ssubfield.itemMinimum"
                      :max="ssubfield.itemMaximum"
                      :number="true"
                      v-model="ssubfield.value"
                      @input="inputFieldChanged"
              >
              </dean-form-row>
            </dean-accordion>

            <dean-select-form-row
                :disabled="status!=='Concept' || subfield.disabled === true || !canUpdateQuote()"
                v-if="subfield.options"
                :label="subfield.label"
                v-model="subfield.value"
                :options="subfield.options"
                @input="inputFieldChanged"
                :clearable="true"
                placeholder="Selecteer"
            >
            </dean-select-form-row>
          </div>

      </div>

      <!-- folding, has childs fields -->
      <div v-if="field.foldable && field.fields">
        <dean-accordion v-if="field.label && !field.folded" :label="field.label">
          <dean-form-row
                  v-for="(subfield, subindex) in field.fields"
                  v-bind:key="subindex"
                  v-if="!subfield.options"
                  :label="subfield.label"
                  v-model="subfield.value"
                  :min="subfield.itemMinimum"
                  :max="subfield.itemMaximum"
                  :number="true"
                  :disabled="status!=='Concept' || !canUpdateQuote()"
                  @input="inputFieldChanged"
          >
          </dean-form-row>
          <dean-select-form-row
                  :disabled="!draft || !canUpdateQuote()"
                  v-for="(subfield, subindex) in field.fields"
                  v-bind:key="subindex"
                  v-if="subfield.options"
                  :label="subfield.label"
                  :options="subfield.options"
                  v-model="fields[index].fields[subindex].model"
                  @input="inputFieldChanged"
                  :clearable="false"
                  placeholder="Selecteer"
          >
          </dean-select-form-row>
        </dean-accordion>
      </div>

    </div>
    <transition name="fade" mode="out-in" style="position: absolute;" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  // VUE
  import Vue from 'vue';
  import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
  import axios from 'axios';

  // COMPONENTS & ICONS
  import {
    trashIcon,
    warningIcon,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSectionDivider,
    deanLoadOverlay,
    goDownIcon,
  } from '@deanone/dean-components';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import deanAccordion from '@/components/deanComponents/deanAccordion.vue';
  import deanIcon from '@/components/deanComponents/deanIcon.vue';
  import deanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
  import DisplayAddress from '@/components/quote/address.vue';

  @Component({
    components: {
      deanIcon,
      trashIcon,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSectionDivider,
      deanFormRow,
      DeanSelectFormRow,
      deanAccordion,
      deanInputSwitchFormRow,
      DisplayAddress,
      deanLoadOverlay,
    },
  })
  export default class QuoteService extends Vue {
    // PROPS
    public trashIcon: object = trashIcon;
    public downIcon: object = goDownIcon;
    public isLoading: boolean = false;

    @Prop() public customer!: string;
    @Prop() public service!: object | null;
    @Prop() public status!: string;

    public data: any = [];
    public address: any = false;
    public addresses: any = false;
    public timeout?: number;

    private readonly baseUrl: string = '/-/trade/api/quote.items';
    private readonly removeServiceUrl: string = '/-/trade/api/quote.service.remove';

    public findProductGroupByName(name: string) {
      const productGroup = (this as any).data.find(
        (item: any) => item.label === name,
      );

      return productGroup;
    }

    public findProductFromProductGroup(productName: string, productGroupName: string) {
      const productGroup = this.findProductGroupByName(productGroupName);

      if (undefined === productGroup) {
        return false;
      }

      const product: any = Object
          .values(productGroup.fields)
          .find((item: any) => item.label === productName);

      return product;
    }

    public checkIfMigrationOrNLSNeedToBeDeselected(field: any) {
      if (
        field.label.search('NLS') === -1
        && field.label !== 'Migratie'
      ) {
        return;
      }

      const nlsProduct: any = this.findProductFromProductGroup('NLS', 'Type levering');
      const migrationProduct: any = this.findProductFromProductGroup('Migratie', 'Type levering');

      if (field.label === 'Migratie') {
        nlsProduct.value = '';
      }

      if (field.label.search('NLS') !== -1) {
        migrationProduct.value = 0;
      }
    }

    public findWithAttr(array: [], attr: string, value: any) {
      for (let i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }

    public sendUpdate() {
      this.isLoading = true;
      const data: any = {
        id: this.$route.params.id,
        service: (this as any).service.id,
        data: (this as any).processFields((this as any).data),
      };

      if ((this as any).service.address) {
        if (!(this as any).address) {
          this.isLoading = false;
          return;
        }
        data.location = this.address.id;
      }

      axios.post(this.baseUrl, data).then(
        (response) => {
          if (response.data) {
            Vue.set(this, 'data', response.data);
            this.$emit('updateService');
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);

          this.isLoading = false;
        },
      );
    }

    public inputFieldChanged(field: any) {
      if (field && !isNaN(Number(field.value)) && field.label !== 'Geen') {
        field.value = field.value ? 0 : 1;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      // enable this for frontend validation
      /*if (field !== '') {
       this.checkIfMigrationOrNLSNeedToBeDeselected(field);
      }*/

      this.timeout = setTimeout(this.sendUpdate, 1500);
    }

    public processFields(fields: any) {
      const result: any = {};
      fields.forEach((item: any) => {
        if (Object.keys(item).includes('fields')) {
          result[item.id] = this.processFields(item.fields);
        } else {
          if (item.value instanceof Object) {
            result[item.id] = item.value.value;
          } else {
            const parsedValue: number = parseInt(item.value, 10);
            result[item.id] = parsedValue > -1 ? parsedValue : 0;
          }
        }
      });

      return result;
    }

    public removeService() {
      this.$emit('removeService', this.address.id);
    }

    public updateAddress(address: any) {
      (this as any).address = address;
      (this as any).redraw();
    }

    public canUpdateQuote(): boolean
    {
      if (this.$store.getters.getUser.privileges.includes('update-quote')) {
        return true;
      }

      return false;
    }

    @Watch('service', {immediate: true})
    private redraw() {
      if (! this.service) {
        return;
      }

      if (! (this as any).service.address) {
        this.address = false;
      }

      this.isLoading = true;
      this.data = [];
      const data: any = {
        id: (this as any).$route.params.id,
        service: (this as any).service.id,
      };

      if ((this as any).service.address) {
        if (! (this as any).address) {
          (this as any).isLoading = false;
          return;
        }
        data.location = this.address.id;
      }

      axios.post(this.baseUrl, data).then(
        (response) => {
          if (response.data) {
            Vue.set(this, 'data', response.data);
          }
          (this as any).$emit('update');
          (this as any).isLoading = false;
        },
        (error) => {
          if (
              (this as any).service.address === true &&
              (
                  error.response.data.errors.code === 'ERR_NEXTPERTISE_CLIENT_EXCEPTION' ||
                  error.response.data.errors.code === 'ERR_NEXTPERTISE_CLIENT_ERROR')
          ) {
            this.$toast({
              icon: warningIcon,
              text: 'Voor dit adres is geen informatie beschikbaar.',
              theme: 'danger',
              title: 'Fout',
            });
          } else {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          }

          (this as any).isLoading = false;
        },
      );
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  :deep(.dean-switch) {
    .slider {
      &.checked.disabled {
        background-color: var(--color-info-success, #09bc9c) !important;
      }
    }
  }

  .dean-section-divider.dean-section-divider-small {
    padding-left: 20px;
  }

  .dean-load-overlay :deep {
    position: absolute;
    min-height: calc(100vh - 80px);

    .dean-overlay {
      position: absolute;
    }
  }
</style>
